<template>
  <div class="grade-resultados-produtos">
    <b-row v-if="resultados.length > 0" data-sbLogPagina="">
      <div
        v-for="produto in resultados"
        :key="produto.codigo"
        class="coluna-produto d-flex"
      >
        <product-item
          :codigo="produto.codigo"
          :multiplo="produto.multiplo"
          :titulo="produto.titulo"
          :tipo_origem_produto="produto.tipo_origem_produto"
          :url_foto="produto.url_foto"
          :cliente_codigo="clienteCodigo"
          :valor_unitario="produto.valor_unitario"
          :estoques="produto.estoques"
          :cd_filial="codigoFilial"
          :valida_estoque="produto.bo_vender_sem_estoque"
          :favorito="produto.favorito"
          @onAddMga="$emit('adicionarMga', $event)"
          @onAddItj="$emit('adicionarItj', $event)"
          @onAdd="$emit('adicionar')"
          @onHideProduct="$emit('ocultarProduto', $event)"
          @onFavoritado="encaminharFavorito"
        >
          <template v-slot:addButton="propriedadesSlot">
            <slot name="addButton" :data="propriedadesSlot.data"></slot>
          </template>
        </product-item>
      </div>
    </b-row>

    <div v-if="carregando" class="text-center">
      <b-spinner
        variant="secondary"
        class="mt-3"
        label="Buscando produtos..."
      ></b-spinner>
    </div>
  </div>
</template>

<script>
import ProductItem from "../ProductItem";

export default {
  name: "gradeResultadosProdutos",
  components: { ProductItem },
  props: {
    resultados: {
      type: Array,
      default: () => [],
    },
    carregando: Boolean,
    clienteCodigo: {
      type: Number,
      default: 0,
    },
    codigoFilial: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    encaminharFavorito(codigoProduto, favorito) {
      this.$emit("favoritar", codigoProduto, favorito);
    },
  },
};
</script>

<style scoped>
@media (min-width: 768px) {
  .coluna-produto {
    margin-left: 1.35%;
    margin-right: 1.35%;
    width: 17%;
  }
}

@media (max-width: 767px) {
  .coluna-produto {
    margin-left: 1.35%;
    margin-right: 1.35%;
    min-height: 20rem;
    width: 100%;
  }
}
</style>
